import { runPlayerCommand } from '../PlayerAccounts/playerCreationOperation'

export const clubInvitationLabels = {
  pending: 'The invitation is queued. Sending has not yet been confirmed.',
  sending: 'The email service is sending the invitation.',
  sent: 'The email server accepted the invitation. This does not confirm delivery to the inbox.',
  failed: 'The invitation could not be sent.',
  unconfirmed: 'Invitation sending is not confirmed. Check its status before requesting another invitation.',
  consumed: 'The owner has used the invitation and activated the account.',
}
const messageForCode = code => ({
  ACCOUNT_ALREADY_EXIST: 'An account already uses this email address. Use a new owner email address.',
  INVITATION_RATE_LIMITED: 'Please wait five minutes between invitation requests.',
  INVITATION_NOT_AVAILABLE: 'This owner account is no longer eligible for an invitation.',
  ERROR_PERMISSIONS: 'Your session does not allow this action. Sign in again and check the result.',
}[code] || (code?.startsWith('INVALID_CLUB') ? 'Some club details are no longer valid. Review the form and reload its options.'
  : 'The result is not confirmed. Check its status before trying again.'))
// Both account flows use the same correlated accounts-response / durable receipt contract.
export const runClubCommand = options => runPlayerCommand({ operation: 'club-created', ...options, messageForCode })
